import { i18nRouting } from '@/src/shared/config';

type SupportedLocale = (typeof i18nRouting.locales)[number];

/**
 * Returns `pathname` with its leading locale segment replaced by `locale`.
 * The app's URLs always carry the locale as the first segment; if it is
 * missing, the locale is prepended.
 */
export function withLocale(pathname: string, locale: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (i18nRouting.locales.includes(segments[0] as SupportedLocale)) {
    segments[0] = locale;
  } else {
    segments.unshift(locale);
  }
  return '/' + segments.join('/');
}
